module.exports = __webpack_public_path__ + "static/img/pcbg.006eca88.jpg";